function formatRuleAmount(value) {
  if (value == null || value === "") return "";
  const num = Number(value);
  if (!Number.isFinite(num)) return String(value).trim();
  return Number.isInteger(num) ? String(num) : String(num);
}

/**
 * 有效用户说明：优先用接口结构化字段 + i18n 模板，避免 summaryText 固定英文。
 * @param {object|null|undefined} effectiveUser
 * @param {(id: string, values?: object) => string} t
 */
export function formatEffectiveUserSummary(effectiveUser, t) {
  if (!effectiveUser) return "";

  const {
    minDepositAmount,
    minDepositCurrency,
    minTradeVolume,
    minTradeVolumeUnit,
    summaryText,
  } = effectiveUser;

  const hasStructured =
    minDepositAmount != null ||
    minDepositCurrency != null ||
    minTradeVolume != null ||
    minTradeVolumeUnit != null;

  if (hasStructured) {
    const depositAmount = formatRuleAmount(minDepositAmount);
    const tradeVolume = formatRuleAmount(minTradeVolume);
    const tradeVolumeUnit = (minTradeVolumeUnit || "USDT").trim();
    const depositCurrency = (minDepositCurrency || tradeVolumeUnit || "USDT").trim();

    if (depositAmount || tradeVolume) {
      return t("home.referralRulesActiveUserDesc", {
        depositAmount,
        depositCurrency,
        tradeVolume,
        tradeVolumeUnit,
      });
    }
  }

  const text = typeof summaryText === "string" ? summaryText.trim() : "";
  return text;
}

/** rewardTiers.tierLabel：接口固定英文，按 upstreamLevel 映射 i18n */
export function formatReferralRewardTierLabel(tier, t) {
  const level = tier?.upstreamLevel;
  if (level === 1) return t("home.referralRulesTierDirectInviter");
  if (level === 2) return t("home.referralRulesTierSecondInviter");
  const label = (tier?.tierLabel || "").trim();
  if (/direct inviter|direct referrer/i.test(label)) return t("home.referralRulesTierDirectInviter");
  if (/second[- ]level inviter|second[- ]level referrer/i.test(label)) {
    return t("home.referralRulesTierSecondInviter");
  }
  return label;
}

/** rebateExamples.exampleTitle：接口固定 "Level 1/2" */
export function formatReferralRebateExampleTitle(example, index, t) {
  const level = index + 1;
  if (level === 1 || /^level\s*1$/i.test(String(example?.exampleTitle || "").trim())) {
    return t("home.referralRulesRow1Tier");
  }
  if (level === 2 || /^level\s*2$/i.test(String(example?.exampleTitle || "").trim())) {
    return t("home.referralRulesRow2Tier");
  }
  return example?.exampleTitle || "";
}

/** rebateExamples.description：接口固定英文描述 */
export function formatReferralRebateExampleDesc(example, index, t) {
  const level = index + 1;
  const desc = String(example?.description || "").trim();
  if (level === 1 || /^A1\b/i.test(desc)) return t("home.referralRulesRow1Desc");
  if (level === 2 || /^A21\b/i.test(desc)) return t("home.referralRulesRow2Desc");
  return desc;
}
